<template>
  <div class="home">

    <div >
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <h4 class="mb-0 me-2">{{$t('credit_invoices')}}</h4>
                        </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center">
                        <div class="input-group pe-4 bg-white rounded border">
                            <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="keyword" :placeholder="$t('search')">
                            <button class="btn p-0" type="button">
                            <AppIcon name="bi-search" class="bi bi-search" style="font-size:18px" />
                            </button>
                        </div>
                        
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="px-8">
                
                <invoice-component :openCreateModal="openCreateModal" @createModalStatus="createModalStatus" :keyword="keyword"></invoice-component>

            </section>
    </div>


  </div>
</template>

<script>
import InvoiceComponent from '../../components/CreditInvoiceComponent.vue'
import helper from '../../helper'

export default {
  name: 'CreditInvoice',
  persistedFilterState: { key: 'credit-invoice-search', fields: ['keyword'] },
  components : {
    InvoiceComponent
  },
  data(){
    return {
        keyword :'',
        count : 0,
        openCreateModal : false
    }
  },
  mounted(){
    window.mixpanel.track("credit_invoice");
    //check permissions
    if(helper.checkAccess('manage_credit_invoices') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('manage_credit_invoices') == -2) return this.$router.push({path : '/subscribe'})
  },
  methods : {
    async create(){
        this.openCreateModal = !this.openCreateModal
    },
    createModalStatus(){}
  }
  
}
</script>
